import React from "react";
import { useCopies } from "shared/hooks/useCopies";
import { useRegDetail } from "shared/context/regDetail";
import { ConfirmationPageEntityType } from "../../../enum";
import { PurchaseConfirmationPropTypes } from "../../types";
import TicketStatus from "shared/enums/TicketStatus";

function MessageBody(props: PurchaseConfirmationPropTypes) {
  const copies = useCopies();
  const { name } = useRegDetail();

  return (
    <div className="purchaseConfirm_msgDetails">
      {props.isInvoicePaymentPending ? (
        <React.Fragment>
          <p
            className="purchaseConfirm_msgDetails--text"
            dangerouslySetInnerHTML={{
              __html: copies.get("invoice.payment.already.requested.to", {
                0: `<strong class="purchaseConfirm_msgDetails--helpdesk">${props.invoicePayerEmail}</strong>`
              })
            }}
          />
          <HelpDeskEmailMessage />
        </React.Fragment>
      ) : (
        <React.Fragment>
          {props.ticketStatus === TicketStatus.COMPLETED && (
            <React.Fragment>
              <p className="purchaseConfirm_msgDetails--text">
                {props.entityType === ConfirmationPageEntityType.TICKET_CHANGE
                  ? // checking `approvalPending` for ticket upgrade offline payment approval pending case
                    props.approvalPending
                    ? copies.get("offline.purchase.ticket.upgrade.pending.review.message", { 0: name })
                    : copies.get("ticket.upgrade.complete.message")
                  : copies.get("ticket.purchase.complete.message")}
              </p>
              {props.approvalPending && <HelpDeskEmailMessage />}
            </React.Fragment>
          )}
          {props.entityType === ConfirmationPageEntityType.GET_TICKLET && props.approvalPending && (
            <React.Fragment>
              <p className="purchaseConfirm_msgDetails--text">
                {copies.get("application.pending.review.message", { 0: name })}
              </p>
              <HelpDeskEmailMessage />
            </React.Fragment>
          )}
          {props.entityType === ConfirmationPageEntityType.BUY_BULK_TICKETS && props.entityQuantity && (
            <React.Fragment>
              <p className="purchaseConfirm_msgDetails--text">
                {props.approvalPending
                  ? copies.get("offline.purchase.meetings.pending.review.message", { 0: name })
                  : copies.get("bulk.ticket.purchase.confirmation.message", { 0: props.entityQuantity })}
              </p>
              {props.approvalPending && <HelpDeskEmailMessage />}
            </React.Fragment>
          )}
          {props.entityType === ConfirmationPageEntityType.BUY_HOSTED_MEETINGS && props.entityQuantity && (
            <React.Fragment>
              <p className="purchaseConfirm_msgDetails--text">
                {props.approvalPending
                  ? copies.get("offline.purchase.bulk.tickets.pending.review.message", { 0: name })
                  : copies.get("meetings.purchase.confirmation.message", { 0: props.entityQuantity })}
              </p>
              {props.approvalPending && <HelpDeskEmailMessage />}
            </React.Fragment>
          )}
        </React.Fragment>
      )}
    </div>
  );
}

export default MessageBody;

function HelpDeskEmailMessage() {
  const copies = useCopies();
  const { helpdeskEmail } = useRegDetail();
  return (
    <p
      className="purchaseConfirm_msgDetails--text"
      dangerouslySetInnerHTML={{
        __html: copies.get("email.support.with.questions", {
          0: `<strong class="purchaseConfirm_msgDetails--helpdesk">${helpdeskEmail}</strong>`
        })
      }}
    />
  );
}
